import React, { useEffect, useState, createRef, useMemo } from 'react';
import { Picky } from 'react-picky';
import Item from './item';

export default function Portfolio({ items = [], types = [], industries = [] }) {
  const portfolioRef = createRef({});

  const initialItems = useMemo(() => {
    return items.map((item) => ({
      id: item.id,
      title: item.title?.rendered,
      link: item.link,
      types: types.filter((type) => item.project_types?.includes(type.id)),
      industries: industries.filter((industry) =>
        item.industries?.includes(industry.id)
      ),
      featuredImage: item._embedded?.['wp:featuredmedia']?.[0],
      status: item.acf?.status,
    }));
  }, [items]);

  const [posts, setPosts] = useState(initialItems);
  const displayedIndustries = industries.filter((a) =>
    initialItems.some((b) => b.industries.some((c) => c.slug === a.slug))
  );

  const [selectedTypes, setTypeFilters] = useState([]);
  const [selectedIndustries, setIndustryFilters] = useState([]);
  const [selectedStatus, setStatusFilters] = useState([]);

  const hasType = selectedTypes.length > 0;
  const hasIndustry = selectedIndustries.length > 0;
  const hasStatus = !!selectedStatus.slug;

  const handleTypeChange = (selected) => {
    setTypeFilters(selected);
  };
  const handleIndustryChange = (selected) => {
    setIndustryFilters(selected);
  };
  const handleStatusChange = (selected) => {
    setStatusFilters(selected);
  };
  const clearTypes = () => {
    setTypeFilters([]);
  };
  const clearIndustries = () => {
    setIndustryFilters([]);
  };
  const clearStatus = () => {
    setStatusFilters([]);
  };

  useEffect(() => {
    if (selectedTypes || selectedIndustries) {
      let filteredPosts = initialItems.filter((p) => {
        return (
          (hasType
            ? p.types?.some((a) => selectedTypes.some((z) => a.slug === z.slug))
            : true) &&
          (hasIndustry
            ? p.industries.some((a) =>
                selectedIndustries.some((z) => a.slug === z.slug)
              )
            : true) &&
          (hasStatus && selectedStatus !== 'all'
            ? p.status === selectedStatus.slug
            : true)
        );
      });
      setPosts(filteredPosts);
    } else {
      setPosts(items);
    }
    // portfolioRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [items, selectedTypes, selectedIndustries, selectedStatus]);

  return (
    <div ref={portfolioRef} className="wp-block-group__inner-container">
      <div className="container">
        <div className="portfolio__filters">
          <span className="portfolio__filter-label">Filter by:</span>
          <div className="portfolio__filter">
            {hasType && (
              <span className="portfolio__filter-label">Project Type</span>
            )}
            <Picky
              className={hasType ? 'active' : null}
              placeholder="Project Type"
              value={selectedTypes}
              valueKey="slug"
              labelKey="name"
              options={types}
              multiple={true}
              numberDisplayed={2}
              onChange={handleTypeChange}
            />
            {hasType && (
              <button className="portfolio__clear-filter" onClick={clearTypes}>
                &times;
              </button>
            )}
          </div>
          <div className="portfolio__filter">
            {hasIndustry && (
              <span className="portfolio__filter-label">Industry</span>
            )}
            <Picky
              className={hasIndustry ? 'active' : null}
              placeholder="Industry"
              value={selectedIndustries}
              valueKey="slug"
              labelKey="name"
              options={displayedIndustries}
              multiple={true}
              numberDisplayed={2}
              onChange={handleIndustryChange}
            />
            {hasIndustry && (
              <button
                className="portfolio__clear-filter"
                onClick={clearIndustries}
              >
                &times;
              </button>
            )}
          </div>
          <div className="portfolio__filter">
            {hasStatus && (
              <span className="portfolio__filter-label">Progress</span>
            )}
            <Picky
              className={hasStatus ? 'active' : null}
              placeholder="Progress"
              value={selectedStatus}
              valueKey="slug"
              labelKey="name"
              options={[
                { slug: 'completed', name: 'Completed' },
                { slug: 'in_progress', name: 'In Progress' },
              ]}
              multiple={false}
              numberDisplayed={2}
              onChange={handleStatusChange}
            />
            {hasStatus && (
              <button className="portfolio__clear-filter" onClick={clearStatus}>
                &times;
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="wp-container-61fbff9f4de2b wp-block-query alignfull">
        <ul className="wp-container-61fbff9f4dcbb is-flex-container columns-4 alignwide wp-block-post-template">
          {posts.map(
            ({ id, title, link, types, industries, featuredImage, status }) => {
              return (
                <Item
                  key={id}
                  id={id}
                  title={title}
                  link={link}
                  types={types}
                  industries={industries}
                  featuredImage={featuredImage}
                  status={status}
                />
              );
            }
          )}
        </ul>
      </div>
    </div>
  );
}
